export enum AuthenticationType {
    Standard = 'Standard',
    AzureActiveDirectory = 'AzureActiveDirectory'
}